import { ErrorHandler, Injectable, Injector } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import * as Sentry from '@sentry/angular-ivy'
import { NotificationService } from './notification.service'
import { TranslateService } from '@ngx-translate/core'

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private sentryErrorHandler = Sentry.createErrorHandler({
    showDialog: false,
  })

  constructor(private injector: Injector) {}

  handleError(error: any) {
    let status = 0

    // Extract status from different error types
    if (error instanceof HttpErrorResponse) {
      status = error.status
    } else if (error && error.rejection && error.rejection.status) {
      status = error.rejection.status
    } else if (error && error.status) {
      status = error.status
    }

    if (status === 502) {
      try {
        const notificationService = this.injector.get(NotificationService)
        const translateService = this.injector.get(TranslateService)
        notificationService.error(
          translateService.instant('error.502.message'),
          translateService.instant('error.502.title'),
        )
      } catch (e) {
        console.error('Could not show 502 notification', e)
      }
      return
    }

    // Ignore AbortError (e.g., cancelled fetch requests)
    const errorMessage = error?.message || error?.rejection?.message || error?.toString() || ''
    if (
      status === 499 ||
      error?.name === 'AbortError' ||
      error?.rejection?.name === 'AbortError' ||
      errorMessage.includes('AbortError') ||
      errorMessage.includes('The user aborted a request')
    ) {
      return
    }

    if (errorMessage.includes('/assets/i18n/')) {
      try {
        const notificationService = this.injector.get(NotificationService)
        const translateService = this.injector.get(TranslateService)

        let title = translateService.instant('error.translation.title')
        if (title === 'error.translation.title') title = 'Chyba načítání'

        let msg = translateService.instant('error.translation.message')
        if (msg === 'error.translation.message')
          msg = 'Nepodařilo se načíst jazykové soubory. Zkuste prosím obnovit stránku (F5).'

        notificationService.error(msg, title)
      } catch (e) {
        console.error('Could not show translation error notification', e)
      }
      return
    }

    const errToExtract = error?.ngOriginalError || error?.rejection || error
    if (
      !errToExtract ||
      (typeof errToExtract === 'object' &&
        Object.keys(errToExtract).length === 0 &&
        !errToExtract.message &&
        !errToExtract.name &&
        !errToExtract.status)
    ) {
      console.warn('Ignored unknown empty error:', error)
      return
    }

    this.sentryErrorHandler.handleError(error)
  }
}
